import {BaseDataService} from "../../../../services/base/BaseDataService";
import { Group } from "../models/Group";
import { GroupQuery } from "../models/GroupQuery";

export class GroupService extends BaseDataService<Group, GroupQuery> {
  protected prefixUrl = `Groups`;

  addUser(groupId: number, login: string) {
    return this.api.post<number>(`${this.prefixUrl}/AddUser?groupId=${groupId}&login=${login}`);
  }
  removeUser(groupId: number, userId: number) {
    return this.api.post<number>(`${this.prefixUrl}/RemoveUser?groupId=${groupId}&userId=${userId}`);
  }
}
